export enum MilestoneTypes {
    GET_MILESTONES = '@@milestones/GET_MILESTONES',
    GET_MILESTONES_SUCCESS = '@@milestones/GET_MILESTONES__SUCCESS',
    GET_MILESTONES_FAIL = '@@milestones/GET_MILESTONES__FAIL',

    GET_MILESTONES_DETAIL = '@@milestones/GET_MILESTONES__DETAIL',
    GET_MILESTONES_DETAIL_SUCCESS = '@@milestones/GET_MILESTONES__DETAIL_SUCCESS',
    GET_MILESTONES_DETAIL_FAIL = '@@milestones/GET_MILESTONES__DETAIL_FAIL',

    ADD_MILESTONES = '@@milestones/ADD_MILESTONES_',
    ADD_MILESTONES_SUCCESS = '@@milestones/ADD_MILESTONES__SUCCESS',
    ADD_MILESTONES_FAIL = '@@milestones/ADD_MILESTONES__FAIL',

    DELETE_MILESTONES = '@@milestones/DELETE_MILESTONES_',
    DELETE_MILESTONES_SUCCESS = '@@milestones/DELETE_MILESTONES__SUCCESS',
    DELETE_MILESTONES_FAIL = '@@milestones/DELETE_MILESTONES__FAIL',

    UPDATE_MILESTONES = '@@milestones/UPDATE_MILESTONES_',
    UPDATE_MILESTONES_SUCCESS = '@@milestones/UPDATE_MILESTONES__SUCCESS',
    UPDATE_MILESTONES_FAIL = '@@milestones/UPDATE_MILESTONES__FAIL',

    GET_MILESTONES_OPERATION_DATA = '@@milestones/GET_MILESTONES_OPERATION_DATA',
    GET_MILESTONES_OPERATION_DATA_SUCCESS = '@@milestones/GET_MILESTONES_OPERATION_DATA_SUCCESS',
    GET_MILESTONES_OPERATION_DATA_FAIL = '@@milestones/GET_MILESTONES_OPERATION_DATA_FAIL',

    GET_MILESTONES_LIFE_EVENTS_DATA = '@@milestones/GET_MILESTONES_LIFE_EVENTS_DATA',
    GET_MILESTONES_LIFE_EVENTS_DATA_SUCCESS = '@@milestones/GET_MILESTONES_LIFE_EVENTS_DATA_SUCCESS',
    GET_MILESTONES_LIFE_EVENTS_DATA_FAIL = '@@milestones/GET_MILESTONES_LIFE_EVENTS_DATA_FAIL',

    ADD_MILESTONES_LIFE_EVENTS = '@@milestones/ADD_MILESTONES_LIFE_EVENTS',
    ADD_MILESTONES_LIFE_EVENTS_SUCCESS = '@@milestones/ADD_MILESTONES_LIFE_EVENTS_SUCCESS',
    ADD_MILESTONES_LIFE_EVENTS_FAIL = '@@milestones/ADD_MILESTONES_LIFE_EVENTS_FAIL',
}
